<div class="confirm-dialog">
  <div class="dialog-header">
    <div class="title">การยืนยัน</div>
    <div class="action">
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="dialog-body">
    <p *ngFor="let item of dialogTitle">
      {{ item }}
    </p>
  </div>
  <div class="dialog-footer">
    <button mat-raised-button (click)="close()">ยกเลิก</button>
    <button mat-raised-button color="accent" (click)="submit()">ตกลง</button>
  </div>
</div>
